import React from 'react';
import PropTypes from 'prop-types';
import { patch } from 'helpers/api';

const PrimaryCompanyButton = ({ companiesPerson }) => {

  PrimaryCompanyButton.propTypes = {
    companiesPerson: PropTypes.shape({
      companies_person: PropTypes.shape({
        contacts_company_id: PropTypes.number,
        contacts_person_id: PropTypes.number,
        created_at: PropTypes.string,
        id: PropTypes.number,
        primary: PropTypes.bool,
        relationship: PropTypes.string,
        updated_at: PropTypes.string
      })
    })
  };

  const makePrimary = () => {
    const data = {
      contacts_companies_person: {
        primary: true
      }
    };
    const personId = companiesPerson.companies_person.contacts_person_id;
    patch(`/contacts/people/${personId}/companies/${companiesPerson.companies_person.id}/make_primary`, { data })
      .then(location.reload());

  };

  return (
    <a className="make-primary-button" onClick={makePrimary}> <span> Make Primary </span> </a>
  );
};

export default PrimaryCompanyButton;